"use client";

import { Skeleton } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";

const HeroSkeleton = () => (
  <Box
    component="section"
    sx={{
      position: "relative",
      height: "628px",
      width: "100%",
      overflow: "hidden",
      pointerEvents: "none"
    }}
    data-testid="hero-section-skeleton"
  >
    <Skeleton animation="wave" variant="rectangular" width="100%" height="100%" />
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 2,
        display: "flex",
        flexDirection: "column",
        padding: { xs: "10px 24px 40px 24px", md: "60px 10px 50px 10px" },
        justifyContent: "center",
        alignItems: "center",
        gap: "100px",
        width: "100%",
        height: "100%",
        textAlign: "center"
      }}
    >
      <Stack gap={{ xs: "60px", md: "70px" }} alignItems="center">
        <Stack
          gap={5}
          sx={{ width: { xs: "342px", sm: "500px", md: "804px" }, textAlign: "center" }}
        >
          <Skeleton variant="rounded" height={50} />
          <Stack alignItems="center">
            <Skeleton variant="text" width="50%" height={30} />
            <Skeleton variant="text" width="70%" height={30} />
          </Stack>
        </Stack>

        <Skeleton variant="rectangular" sx={{ borderRadius: 20 }} width="50%" height={50} />
      </Stack>
      <Stack
        alignItems="center"
        spacing={2}
        sx={{ width: { xs: "342px", sm: "500px", md: "804px" } }}
      >
        <Stack direction="row" spacing={2} justifyContent="center">
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="circular" width={20} height={20} />
        </Stack>
        <Skeleton variant="text" height={20} sx={{ width: { xs: "70%", md: "50%" } }} />
      </Stack>
    </Box>
  </Box>
);

export default HeroSkeleton;
